import api from './api';

const prefix = '/submit-results';

const submitResultsService = {
  getByProject: async (projectId) => {
    const response = await api.get(`${prefix}/${projectId}`);
    return response.data;
  },
  uploadAndExtract: async (file, projectId) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('projectId', projectId);

    const response = await api.post(`${prefix}/upload-and-extract`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
  save: async (projectId, formData) => {
    const response = await api.post(`${prefix}/save`, {
      projectId,
      formData,
    });
    return response.data;
  },
  exportXml: async (projectId) => {
    const response = await api.post(`${prefix}/${projectId}/export-xml`);
    return response.data;
  },
};

export default submitResultsService;

